export enum ExecutionStateEnum {
    NotStarted = 0,
    Running = 1,
    Completed = 2,
    Failed = 3
}
